
// zip-async.validator.ts
import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService, ZipInfo } from 'src/app/shared/services/api.service';

@Injectable({ providedIn: 'root' })
export class ZipAsyncValidator implements AsyncValidator {
  // Optional: expose last resolved info (if you want to reuse values later)
  private lastInfo: ZipInfo | null = null;

  constructor(private zipService: ApiService) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const zip = (control.value ?? '').toString().trim();

    
    if (!/^\d{5}$/.test(zip)) {
      this.lastInfo = null;
      return of(null);
    }

    return this.zipService.getLocationInfo(zip).pipe(
      map((info) => {
        
        this.lastInfo = info
        
        if (info?.error) {
            return { zipNoLocation: true }; 
         }
         return null;
      }),
      catchError(() => {
        this.lastInfo = null;
        // Mark control invalid with a custom error key
        return of({ zipNotFound: true });
      })
    );
  }

  /** Optional getter for city/state (if you need to use later on submit) */
  get resolvedInfo(): ZipInfo | null {
    return this.lastInfo;
  }
}
